module.exports = __webpack_public_path__ + "static/media/lab.f1bea910.png";